<app-dashboard-box [title]="'common.title.device-list' | translateSafe"
                   icon="map">

  <div box-actions
       class="toolbar-buttons">
    <app-input-select-button [formData]="mapLayout"/>
  </div>

  <div class="toolbar-buttons sub-title"
       sub-title>
    <div class="actions">
      <app-input-text [formData]="searchDeviceSelect"/>

      <div class="row">
        <app-input-select [formData]="deviceStatusSelect"/>

        <app-input-select [formData]="deviceModelSelect"/>
      </div>

      <app-text-label [label]="'common.fields.device-count' | translateSafe : {
                        count: getDeviceCount(),
                        total: getDeviceTotal()
                      }"
                      class="yellow"/>
    </div>
  </div>

  <div #fullMapContainer
       (click)="$event.stopPropagation()"
       class="map-container">
  </div>
</app-dashboard-box>
@if (isDeviceDetailOpen) {
  <app-dialog-base (click)="closeShowDetails()"
                   [buttonAction]="closeShowDetails"
                   [class.open]="isDeviceDetailOpen"
                   [title]="'dialogs.device.showed-device' | translateSafe : {device: selectedDevice?.serial_number ||
                 '-'}"
                   iconLeft="info">
    <app-dialog-device-detail #showDeviceDetails
                              [device]="selectedDevice"/>
  </app-dialog-base>
}
